import { AgencyTypeId, agencyTypeIdDetailed } from '@app/models';
import { baseOperationPoint } from '@app/pcs/models';
import { pathSectionCatalogDataDetailed } from '@dossier/models/catalog-data';
import { Path } from '@dossier/models/path';
import { PathSection } from '@dossier/models/path-section';
import { Territory } from '@dossier/models/territory';
import { usedCatalogDataDetailed } from '@dossier/models/used-catalog-data';
import { gql } from 'apollo-angular';

export interface CopyTrainParameters {
  ttp?: any;
  trainType?: any;
  timetableId?: number;
  basePathSection?: PathSection;
  territory?: Territory;
  groups?: number[];

  imParameters?: boolean;
  commonTrainParams?: boolean;
  commonTrainParamsLocoTypes?: boolean;
  dossierLevelParameters?: boolean;
  comments?: boolean;
  destinationOptions?: CopyPathSectionOption[];
  agencyTypeId?: AgencyTypeId;
}

export interface CopyOptionsDestination {
  subPath: Path;
  selected: boolean;
  groupById?: number;
}

export interface CopyPathSectionOption {
  basePathSection: boolean;
  pathSection: PathSection;
  selected: boolean;
  subPaths: CopyOptionsDestination[];
  indeterminate?: boolean;
}

export const pathSectionDestinationOptions = gql`
  fragment pathSectionDestinationOptions on CopyPathSectionOption {
      pathSection {
        id
        operationPoint {
          ...baseOperationPoint
        }
        usedCatalogData {
          ...usedCatalogDataDetailed
        }
        catalogData {
          ...pathSectionCatalogDataDetailed
        }
        timetableId
      }
      basePathSection
      selected
      subPaths {
        pathSectionId
        subPath {
          id
          sortOrder
        }
        selected
        groupById
        territorySortOrder
      }
      indeterminate

  }
  ${baseOperationPoint}
  ${usedCatalogDataDetailed}
  ${pathSectionCatalogDataDetailed}
`;


export const copyTrainParametersDetailed = gql`
  fragment copyTrainParametersDetailed on CopyTrainParameters {
    imParameters
    commonTrainParams
    commonTrainParamsLocoTypes
    comments
    dossierLevelParameters
    basePathSection {
      id
    }
    territory {
      id
      responsiblePair {
        sortOrder
      }
      subPaths {
        id
        sortOrder
      }
    }
    groups
    destinationOptions {
       ...pathSectionDestinationOptions
    }
    agencyTypeId {
      ...agencyTypeIdDetailed
    }
  }
  ${pathSectionDestinationOptions}
  ${usedCatalogDataDetailed}
  ${pathSectionCatalogDataDetailed}
  ${agencyTypeIdDetailed}
`;
